import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=2037c97a&scoped=true&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=2037c97a&scoped=true&lang=css&"
import style1 from "./Calendar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037c97a",
  null
  
)

export default component.exports